/** Destino por defecto de un usuario autenticado. */
export const HOME_ROUTE = '/train';

/**
 * Normaliza el parámetro `redirect` de `/login`.
 *
 * Sólo se aceptan rutas internas: cualquier cosa que empiece por `//` o por un
 * esquema (`https:`, `javascript:`...) permitiría un salto a un dominio ajeno
 * después de iniciar sesión.
 */
export function safeRedirect(target: unknown): string {
  if (typeof target !== 'string' || target === '') return HOME_ROUTE;
  if (!target.startsWith('/') || target.startsWith('//')) return HOME_ROUTE;
  // `/login` y `/register` como destino dejarían al usuario dando vueltas.
  if (target === '/login' || target === '/register') return HOME_ROUTE;
  return target;
}
